<template>
  <div
    v-if="isProductAttributesEnabled"
    class="productAttributes"
    :style="{ top: top + 'px', right: right + 'px' }"
  >
    <info-icon
      v-if="showInfoIcon"
      :product="product"
      @infoIconClicked="showProductAttributesModal(product)"
    />
    <img
      v-for="(apa, apa_index) in activeProductAttributes(product)"
      :key="apa.id + '-' + apa_index"
      :src="apa.image"
    />
  </div>
</template>

<script>
import { getTranslation } from "@/utils/helpers";
import _, { isEmpty } from "lodash";
import InfoIcon from "@/components/common/InfoIcon.vue";
import { isProductAttributesEnabled } from "@/utils/templateSettings";
import { mapGetters } from "vuex";

export default {
  name: "ProductAttributeIconsOverlay",
  components: { InfoIcon },
  props: {
    product: Object,
    top: {
      type: Number,
      default: 10
    },
    right: {
      type: Number,
      default: 10
    },
    showInfoIcon: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    productIsEmpty() {
      return _.isEmpty(this.product);
    },
    attributesAreEmpty() {
      if (this.productIsEmpty()) {
        return true;
      }
      if (_.isEmpty(this.product.attributes)) {
        return true;
      }
      return _.isEmpty(this.productAttributes);
    },
    confirmProductAttributes(p) {
      this.$emit("onConfirmProductAttributes", p);
    },
    showProductAttributesModal(item) {
      console.log("showProductAttributesModal");
      if (this.productIsEmpty()) {
        return;
      }
      const params = {
        product: this.product,
        assignedProductAttributes: this.assignedProductAttributes(item),
        onConfirm: p => {
          return this.confirmProductAttributes(p);
        }
      };
      this.$productAttributesModal.show(params);
    },
    activeProductAttributes(product) {
      if (this.attributesAreEmpty()) {
        return [];
      }
      return this.productAttributes
        .filter(
          pa => pa.hide === false && product.attributes.find(ia => pa.id === ia)
        )
        .sort((c1, c2) => {
          return c2.order_by - c1.order_by;
        });
    },
    assignedProductAttributes(product) {
      if (this.attributesAreEmpty()) {
        return [];
      }
      return this.productAttributes.filter(pa =>
        product.attributes.find(ia => pa.id === ia)
      );
    }
  },
  computed: {
    ...mapGetters({
      productAttributes: "PRODUCT_ATTRIBUTES"
    }),
    isProductAttributesEnabled: isProductAttributesEnabled
  }
};
</script>

<style lang="scss" scoped>
.productAttributes {
  position: absolute;
  z-index: 100;
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  gap: 6px;
}

.productAttributes img {
  width: 32px;
  height: 32px;
  object-fit: contain;
}
</style>
